import {LANGUAGE_LABELS} from 'rlink-regions/constants';

export default function getSupportedLanguages () {
  return Object.keys(LANGUAGE_LABELS);
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getSupportedLanguages.js